import { b64toBlob } from "../util";
import { useScreenOrientation } from "../lib/toda-react/src/hooks.js";

export default function Attachment({ file }) {
  let { fileName, fileMime, content } = file;
  let blob = b64toBlob(content, fileMime);
  let url = URL.createObjectURL(blob);

  let screenOrientation = useScreenOrientation();

  function Preview({ fileMime, url }) {
    let css = "~ml-3 ~px-2 ~py-1 rounded text-wrap break-words size-full min-h-[50rem] aspect-square";
    switch (fileMime) {
      case fileMime.match(/^image/)?.input: // HACKY: but works; can also be enumerated one by one.
        return <p className={css}>
          {fileMime.startsWith('image') && <img src={url} />}
        </p>;
      case "application/pdf":
        return <iframe src={url} className={css + `h-`}></iframe>
    }
  }

  return <Preview fileMime={fileMime} url={url}/>
  return <details className="w-full" open={screenOrientation == "landscape"}>
    <summary className="cursor-pointer">
      <span>{fileName || "attachment"}</span>
      {/* <a href={url} download={fileName} title="Download asset"
        className="float-right pl-7 h-5 hover:underline bg-[url(/public/img/download-file.svg)] bg-no-repeat">
        Download
      </a> */}
    </summary>
    <Preview fileMime={fileMime} url={url}/>
  </details>
}
